module.exports = __webpack_public_path__ + "img/icon-bonesbodies.e12e5e36.png";